import TransactionHistoryActions from "@frameworks/web/redux/actions/Reports/TransactionHistory";
export default () => {
    return {
        transactionHistory: new TransactionHistoryActions(),
    };
};
